import { render, staticRenderFns } from "./TelemetryEventDefaultOverlay.vue?vue&type=template&id=bdd9f5a4&"
import script from "./TelemetryEventDefaultOverlay.vue?vue&type=script&lang=js&"
export * from "./TelemetryEventDefaultOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports